module.exports = __webpack_public_path__ + "static/img/6.bc0d949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/6.png
// module id = Wzg0
// module chunks = 0